<template>
  <div>
    <div class="container-fluid p-0 push-wrapper">
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="row">
              <div class="col-12 my-header font-weight-bold">
                Настройка склада
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container mt-5" v-if="loading">
        <div class="row">
          <div class="col">
            <div class="loader_holder" style="margin: 0 auto; width: 200px">
              <object
                type="image/svg+xml"
                data="/assets/loaders/infinity.svg"
              ></object>
              <div class="col-12 loading_text text-center">
                {{ "Загрузка" }}...
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container mt-5" v-if="!loading">
        <div class="row">
          <breadcrumbs
            :warehouse="warehouse"
            :route="$route"
            :breadcrumbs="[
              { name: 'Склады', link: '/inventory/warehouses' },
              {
                name: warehouse.name,
                link: '/inventory/warehouses/' + warehouse.id,
              },
              { name: 'Настройка', update: true },
            ]"
            @Update="update"
          />
        </div>
        <div class="row">
          <div class="col-12">
            <!-- Tabs  -->
            <div class="tabs">
              <div
                class="tab"
                v-for="sup of [
                  { id: 'main', name: 'Основные' },
                  { id: 'employee', name: 'Сотрудники' },
                  { id: 'contacts', name: 'Контакты склада' },
                  { id: 'letter', name: 'Шаблон писем' },
                ]"
                @click="
                  tabs.active = sup.id;
                  $router.history.push('#' + sup.id);
                "
                :class="{ active: tabs.active == sup.id }"
                :key="'supid_tab_letter' + sup.id"
              >
                {{ sup.name }}
              </div>
            </div>
          </div>
        </div>

        <!-- Основные: название и алерт от кол-ва товара  -->
        <template v-if="tabs.active == 'main'">
          <div class="row mt-4">
            <div class="col-12">
              <input-module
                type="text"
                title="Название склада"
                v-model="warehouse.name"
                placeholder="Например, Лефортово"
                :saveButton="true"
                @onSave="saveWarehouseName"
              />
              <input-module
                type="text"
                title="Адрес склада"
                v-model="warehouse.address"
                placeholder="Например, Москва, ул. Пушкина, д. 1"
                :saveButton="true"
                @onSave="saveWarehouseAddress"
              />
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-12">
              <input-module
                type="number"
                title="Предупреждение о нехватке товара"
                v-model="warehouse.minimal_item_amount"
                placeholder="Например, 5"
                about="Укажите количество товара, ниже которого склад будет предупреждать об его окончании."
                :saveButton="true"
                @onSave="saveWarehouseMinimalItemAmount"
              />
            </div>
          </div>
        </template>

        <!-- Сотрудники  -->
        <template v-if="tabs.active == 'employee'">
          <div class="row mt-4">
            <employee_component
              :employee="employee"
              @Changed="employeeChanged"
            />
            <shop_settings
              :warehouse_id="$route.params.id"
              :employee="employee"
            />
            <div class="col-12">
              <employee_logs
                :employee_logs="employee_logs"
                :loaded="true"
                :employee_logs_columns="employee_logs_columns"
              />
            </div>
          </div>
        </template>

        <!-- Контакты  -->
        <template v-if="tabs.active == 'contacts'">
          <div class="row mt-4">
            <div class="col-12">
              <template
                v-if="!warehouse.contacts || warehouse.contacts.length == 0"
              >
                Создайте первый контакт сотрудника склада!
                <br />
                <button class="styled mt-3" @click="openCreateContact">
                  <i class="fal fa-plus"></i>
                  Создать контакт
                </button>
              </template>
              <template v-else>
                <h3>
                  Контакты
                  <button class="add_one" @click="openCreateContact">
                    <i class="fal fa-plus-circle" style="margin-right: 5px">
                    </i>
                    Добавить
                  </button>
                </h3>
                <div
                  v-for="(contact, i) of warehouse.contacts"
                  :key="'contact' + contact.value + contact.name"
                >
                  {{ contact.value }} - {{ contact.name }}
                  <button
                    class="contact_action"
                    @click="openEditContact(contact, i)"
                  >
                    <i class="fal fa-edit"></i>
                  </button>
                  <button class="contact_action" @click="deleteContact(i)">
                    <i class="fal fa-trash-alt"></i>
                  </button>
                </div>
              </template>
            </div>
          </div>
        </template>

        <!-- Шаблоны писем  -->
        <template v-if="tabs.active == 'letter'">
          <div class="row mt-4" v-if="warehouse.letter_template">
            <div class="col-8">
              <h4>Заголовок</h4>
              <wysiwyg v-model="warehouse.letter_template.header" />
            </div>
            <div class="col">
              <div
                class="letter_demo"
                v-html="parseLetter(warehouse.letter_template.header)"
              ></div>
            </div>
          </div>
          <div class="row mt-4" v-if="warehouse.letter_template">
            <div class="col-8">
              <h4>Список товаров</h4>
              <wysiwyg v-model="warehouse.letter_template.list" />
            </div>
            <div class="col">
              <div
                class="letter_demo"
                v-html="parseLetter(warehouse.letter_template.list)"
              ></div>
            </div>
          </div>
          <div class="row mt-4" v-if="warehouse.letter_template">
            <div class="col-8">
              <h4>Подвал</h4>
              <wysiwyg v-model="warehouse.letter_template.footer" />
            </div>
            <div class="col">
              <div
                class="letter_demo"
                v-html="parseLetter(warehouse.letter_template.footer)"
              ></div>
            </div>
          </div>
          <div class="row mt-4" v-if="warehouse.letter_template">
            <div class="col-12">
              <h4>Переменные</h4>
              <ul>
                <li>[CLIENTNAME] - Название склада</li>
                <li>[CLIENTADDRESS] - Адрес склада</li>
                <li>[POSITIONS] - Автоматически генерируемый список товаров</li>
                <li>[CLIENTCONTACTS] - Список контактов склада</li>
              </ul>
            </div>
          </div>
          <div class="row mt-4" v-if="warehouse.letter_template">
            <div class="col-12">
              <h4>Демонстрация шаблона</h4>
              <div
                v-html="
                  parseLetter(
                    warehouse.letter_template.header +
                      warehouse.letter_template.list +
                      warehouse.letter_template.footer
                  )
                "
              ></div>
            </div>
          </div>
          <div class="row mt-4" v-if="warehouse.letter_template">
            <div class="col-12">
              <button class="styled" @click="saveLetterTemplate">
                Сохранить
              </button>
            </div>
          </div>
        </template>
      </div>
    </div>
    <contact_edit_popup
      ref="contact_popup"
      @CreateOrUpdateClient="CreateOrUpdateClient"
    />
  </div>
</template>

<script>
import moment from "moment";
import apiDriver from "../../apiDriver";
let copyObject = require("./copyObject").default;

import breadcrumbs from "./components/breadcrumbs";
import employee_component from "./components/employee";
import shop_settings from "./components/shop_settings";
import employee_logs from "./components/employee_logs";
import contact_edit_popup from "./components/contact_edit_popup";
import swal from "sweetalert2";

export default {
  components: {
    breadcrumbs,
    employee_component,
    shop_settings,
    employee_logs,
    contact_edit_popup,
  },
  data() {
    return {
      loading: true,
      warehouse: {
        id: null,
        name: "Загрузка склада...",
        contacts: null,
        address: null,
        letter_template: null,
        minimal_item_amount: null,
      },
      employee: [],
      employee_logs: [],
      employee_logs_columns: [
        {
          label: "ID",
          field: "id",
          type: "number",
          width: 50,
        },
        {
          label: "Сотрудник",
          field: "employee_name",
          type: "text",
          filterOptions: {
            enabled: true,
            filterDropdownItems: [],
            placeholder: "Сотрудник",
          },
        },
        {
          label: "Действие",
          field: "action_name",
          type: "text",
          filterOptions: {
            enabled: true,
            filterDropdownItems: [],
            placeholder: "Действие",
          },
        },
        {
          label: "Дата и время",
          field: "createdAt",
          type: "date",
          dateInputFormat: "dd.MM.yyyy HH:mm",
          dateOutputFormat: "dd.MM.yyyy HH:mm",
        },
      ],
      tabs: {
        active: "main",
      },
    };
  },
  mounted() {
    console.log(
      "warehouse mounted",
      this.$route,
      this.$router,
      this.$breadcrumbs
    );
    if (this.$route.hash) {
      this.tabs.active = this.$route.hash.substr(1);
    }
    this.update();
  },
  methods: {
    saveWarehouseAddress(data) {
      console.log("saveWarehouseAddress", data);

      apiDriver.services.api
        .post("inventory", "store/address", {
          store_id: this.warehouse.id,
          address: data.toString(),
        })
        .then(() => {
          this.$toast.success("Адрес сохранен");
        });
    },
    saveLetterTemplate() {
      console.log("saveLetterTemplate", this.warehouse.letter_template);
      apiDriver.services.api
        .post("inventory", "store/letter_template", {
          store_id: this.warehouse.id,
          letter_template: this.warehouse.letter_template,
        })
        .then(() => {
          this.$toast.success("Шаблон сохранен");
        });
    },
    saveWarehouseMinimalItemAmount(data) {
      console.log("saveWarehouseMinimalItemAmount", data);

      apiDriver.services.api
        .post("inventory", "store/minimal_item_amount", {
          store_id: this.warehouse.id,
          minimal_item_amount: data,
        })
        .then(() => {
          this.$toast.success("Сохранено");
        });
    },
    saveWarehouseName(data) {
      console.log("saveWarehouseName", data);

      apiDriver.services.api
        .post("inventory", "store/name", {
          store_id: this.warehouse.id,
          name: data.toString(),
        })
        .then(() => {
          this.$toast.success("Название сохранено");
        });
    },
    CreateOrUpdateClient(data) {
      console.log("CreateOrUpdateClient", data);
      if (data.i == -1) {
        // new contact
        if (!this.warehouse.contacts) this.warehouse.contacts = [];
        this.warehouse.contacts.push(data.contact);
      } else {
        // update contact
        this.warehouse.contacts[data.i].value = data.contact.value;
        this.warehouse.contacts[data.i].name = data.contact.name;
      }
      apiDriver.services.api
        .post("inventory", "store/contacts", {
          store_id: this.warehouse.id,
          contacts: this.warehouse.contacts,
        })
        .then(() => {
          this.$toast.success("Контакты обновлены");
        });
    },
    openCreateContact() {
      this.$refs.contact_popup.openModal();
    },
    openEditContact(contact, i) {
      this.$refs.contact_popup.openModal({ contact, i });
    },
    deleteContact(i) {
      swal({
        title: "Удалить контакт?",
        text: "Вы уверены, что хотите удалить контакт?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Да, удалить!",
        cancelButtonText: "Отмена",
      }).then((result) => {
        if (result) {
          this.warehouse.contacts.splice(i, 1);
          apiDriver.services.api
            .post("inventory", "contacts", {
              store_id: this.warehouse.id,
              contacts: this.warehouse.contacts,
            })
            .then(() => {
              this.$toast.success("Контакт удален");
            });
        }
      });
    },
    async update() {
      console.log("warehouse update");
      this.loading = true;
      await this.loadWarehouse();
      await this.loadEmployee();
      await this.loadEmployeeLogs();
      this.loading = false;
    },
    async loadWarehouse() {
      let id = this.$route.params.id;
      let warehouse = await apiDriver.services.api.get("inventory", "store", {
        id,
      });
      if (!warehouse) return this.$toast.error("Ошибка загрузки склада");
      warehouse = warehouse.data;
      this.warehouse = warehouse.store;
      let letter_demo = {
        header:
          "<p>Добрый день!<br>Необходима поставка партии табака в <b>[CLIENTNAME]</b> по адресу <b>[CLIENTADDRESS]</b>.</p>",
        list: "<p>Позиции:<br>[POSITIONS]</p>",
        footer: "<p>Контакты:<br>[CLIENTCONTACTS]</p>",
      };
      if (!this.warehouse.letter_template) {
        this.warehouse.letter_template = letter_demo;
      } else {
        if (!this.warehouse.letter_template.header) {
          this.warehouse.letter_template.header = letter_demo.header;
          this.warehouse.letter_template.list = letter_demo.list;
          this.warehouse.letter_template.footer = letter_demo.footer;
        }
      }
      console.log("load warehouse:", warehouse);
    },
    async loadEmployee() {
      let id = this.$route.params.id;
      let employee = (
        await apiDriver.services.api.get("inventory", "employee/list", { id })
      ).data.list;
      console.log("employee:", employee);
      for (let e of employee) e.secret_code = "- --- ---";
      for (let e of employee) e.removing = false;
      for (let e of employee) e.quick_key_timing = 0;
      this.employee = employee;
    },
    async loadEmployeeLogs() {
      let id = this.$route.params.id;
      let employee_logs = (
        await apiDriver.services.api.get("inventory", "employee/logs", { id })
      ).data.list;
      let employee_names = [];
      let action_names = [];
      let logs = [];
      for (let e of employee_logs) {
        e.createdAt = moment(e.createdAt).format("DD.MM.YYYY HH:mm");
        e.employee_name = (
          this.employee.find((x) => x.id == e.employee_id) || { name: "неизв." }
        ).name;
        e.action_name = e.action;
        if (e.action == "login") e.action_name = "Вход в систему";
        if (e.action == "verifyEmployee")
          e.action_name = "Успешная верификация";
        if (e.action == "compsuption") e.action_name = "Создан расход";
        if (e.action == "getCodes")
          e.action_name = "Получение кодов пользователей";
        if (!employee_names.includes(e.employee_name))
          employee_names.push(e.employee_name);
        if (!action_names.includes(e.action_name))
          action_names.push(e.action_name);
        logs.push({
          id: e.id,
          action_name: e.action_name,
          employee_name: e.employee_name,
          createdAt: e.createdAt,
        });
      }
      console.log("loadEmployeeLogs", logs, action_names, employee_names);
      for (let c of this.employee_logs_columns) {
        if (c.filterOptions) {
          if (c.filterOptions.filterDropdownItems) {
            let list = [];
            if (c.field == "action_name") list = action_names;
            if (c.field == "employee_name") list = employee_names;
            if (list.length == 0) {
              c.hidden = true;
            } else {
              c.hidden = false;
            }
            c.filterOptions.filterDropdownItems = list;
          }
        }
      }
      this.employee_logs = logs;
    },
    // employee
    employeeChanged({ type, employee_id, new_data }) {
      if (type == "create") {
        // new_data
        this.employee.push(new_data);
      } else if (type == "remove") {
        // employee_id
        this.employee = this.employee.filter((x) => x.id != employee_id);
      }
    },
    parseLetter(letter_proto) {
      letter_proto = letter_proto.replace(
        /\[POSITIONS\]/g,
        "<ul><li>Наименование товара, 200 гр — 5 шт.</li><li>Наименование товара 2, 200 гр — 3 шт.</li></ul>"
      );
      letter_proto = letter_proto.replace(
        /\[CLIENTNAME\]/g,
        this.warehouse.name
      );
      letter_proto = letter_proto.replace(
        /\[CLIENTADDRESS\]/g,
        this.warehouse.address
      );
      let cntcs = this.warehouse.contacts || [];
      letter_proto = letter_proto.replace(
        /\[CLIENTCONTACTS\]/g,
        cntcs
          .map((x) => `${x.value}${x.name ? " (" + x.name + ")" : ""}`)
          .join("<br>")
      );
      return letter_proto;
    },
  },
};
</script>


<style lang="scss" scoped>
.contact_action {
  color: inherit;
  background: unset;
  border: unset;
  outline: unset;
  cursor: pointer;
}

.letter_demo {
  padding-top: 80px;
}

.tabs {
  border-bottom: 2px solid #eee;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  .tab {
    display: inline-block;
    padding: 5px 10px;
    border-bottom: 2px solid #eee;
    position: relative;
    bottom: -2px;
    cursor: pointer;

    &:hover {
      border-color: #a54ce7;
    }

    &.active {
      border-color: #8a00ef;
    }
  }
}
</style>

<style lang="scss" scoped>
@media (prefers-color-scheme: dark) {
  .tabs {
    border-bottom: 2px solid #4c4c4c;
    .tab {
      border-bottom: 2px solid #4c4c4c;
      &.active {
        border-color: #6b68cb;
      }
      &:hover {
        border-color: #6b68cb;
      }
    }
  }
}
</style>